<nav class="nav" aria-label="Hauptnavigation">
    <ul class="nav__list">
        <li class="nav__item" [class.nav__item--active]="router.isActive('home', true)">
            <a routerLink="/home">Start</a>
        </li>
        <li class="nav__item" [class.nav__item--active]="router.isActive('speiseplan', true)">
            <a routerLink="/speiseplan">Speiseplan</a>
        </li>
        <li class="nav__item">
            <a href="https://www.metzgerei-rettensteiner-scharfetter.at/speisekarte.pdf"
               target="_blank"
               rel="noopener">Speisekarte</a>
        </li>
        <li class="nav__item" [class.nav__item--active]="router.isActive('qualität', true)">
            <a routerLink="/qualität">Qualität</a>
        </li>
        <li class="nav__item" [class.nav__item--active]="router.isActive('kontakt', true)">
            <a routerLink="/kontakt">Kontakt</a>
        </li>
    </ul>
</nav>

<div class="nav__mobile">
    <button type="button"
            class="nav__mobile__button"
            [matMenuTriggerFor]="mainMenu"
            aria-label="Menü öffnen">
        <svg class="nav__mobile__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M3 6.5h18v1.6H3V6.5zm0 4.7h18v1.6H3v-1.6zm0 4.7h18v1.6H3v-1.6z"/>
        </svg>
        <span class="nav__mobile__label">Menü</span>
    </button>
    <mat-menu #mainMenu="matMenu" yPosition="below" class="nav__mobile__panel">
        <button mat-menu-item routerLink="home">
            <span>Startseite</span>
        </button>
        <button mat-menu-item routerLink="speiseplan">
            <span>Speiseplan</span>
        </button>
        <a mat-menu-item
           href="https://www.metzgerei-rettensteiner-scharfetter.at/speisekarte.pdf"
           target="_blank"
           rel="noopener">Speisekarte</a>
        <button mat-menu-item routerLink="qualität">
            <span>Qualität</span>
        </button>
        <button mat-menu-item routerLink="kontakt">
            <span>Kontakt</span>
        </button>
        <a mat-menu-item
           class="nav__mobile__order"
           href="https://bestellen.marktstubn.com/"
           target="_blank"
           rel="noopener">Vorbestellen</a>
    </mat-menu>
</div>
